module.exports = __webpack_public_path__ + "static/media/logo-head.385f8760.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-head.svg
// module id = 112
// module chunks = 0